import EmblaCarousel from 'embla-carousel';

const OPTIONS = {
  loop: true,
  dragFree: false,
  active: true,
  breakpoints: {}
};

const initializeEmbla = () => {

  const emblaNode = document.querySelector('.embla');
  if (!emblaNode) return; // Prevent errors if Embla is not found

  const viewportNode = emblaNode.querySelector('.embla__viewport');
  const prevBtn = emblaNode.querySelector('.embla__button--prev');
  const nextBtn = emblaNode.querySelector('.embla__button--next');
  const progressNode = emblaNode.querySelector('.embla__progress__bar');

  const emblaApi = EmblaCarousel(viewportNode, OPTIONS);
  
  const { applyProgress, removeProgress } = setupProgressBar(emblaApi, progressNode);
  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn);

  emblaApi
    .on('init', applyProgress)
    .on('reInit', applyProgress)
    .on('scroll', applyProgress)
    .on('slideFocus', applyProgress)
    .on('destroy', removeProgress)
    .on('destroy', removePrevNextBtnsClickHandlers);
};

const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
  const togglePrevNextBtnsState = () => {
    prevBtn.disabled = !emblaApi.canScrollPrev();
    nextBtn.disabled = !emblaApi.canScrollNext();
  };

  emblaApi
    .on('select', togglePrevNextBtnsState)
    .on('init', togglePrevNextBtnsState)
    .on('reInit', togglePrevNextBtnsState);

  return () => {
    prevBtn.disabled = false;
    nextBtn.disabled = false;
  };
};

export const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
  const scrollPrev = () => emblaApi.scrollPrev();
  const scrollNext = () => emblaApi.scrollNext();

  prevBtn.addEventListener('click', scrollPrev, false);
  nextBtn.addEventListener('click', scrollNext, false);

  const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn);

  return () => {
    removeTogglePrevNextBtnsActive();
    prevBtn.removeEventListener('click', scrollPrev, false);
    nextBtn.removeEventListener('click', scrollNext, false);
  };
};

export const setupProgressBar = (emblaApi, progressNode) => {
  const applyProgress = () => {
    const progress = Math.max(0, Math.min(1, emblaApi.scrollProgress()));
    progressNode.style.transform = `translate3d(${progress * 100}%,0px,0px)`;
  };

  const removeProgress = () => {
    progressNode.removeAttribute('style');
  };

  return { applyProgress, removeProgress };
};

// Explicitly export initialization function
export default initializeEmbla;